<template>
  <div>
    <div class="my-student-head">
      <van-dropdown-menu>
        <van-dropdown-item v-model="yId" :options="yearList" @change="yChange" />
        <van-dropdown-item v-model="sId" :options="sessionList" @change="sChange" />
      </van-dropdown-menu>
    </div>
    <div class="my-student-count">{{list.length}}名学生</div>
    <div class="my-student-body">
      <div v-for="item in list" :key="item.StudentID" class="list">
        <div class="nowrap list-info">
          <div class="student-name nowrap">
            <b>{{ item.StudentName }}</b>
            <span>（{{ item.SexShow }}）</span>
          </div>
          <div class="student-username nowrap">用户名：{{ item.UserName }}</div>
          <div class="student-classname nowrap">班级：{{ item.ClassName }}</div>
        </div>
        <div>
          <div class="xy-public-btn" @click="detialsBtn(item)">详情</div>
        </div>
      </div>
    </div>
    <my-student-details :isClose="isClose" :row="row" @listenToClose="close"></my-student-details>
  </div>
</template>
<script>
import MyStudentDetails from "@/pages/schoolAffairs/views/tutor/MyStudentDetails";
export default {
  name: "myexam",
  components: {
    MyStudentDetails
  },
  data() {
    return {
      isClose: false,
      yId: "",
      sId: "",
      list: [],
      yearList: [],
      sessionList: [],
      row: {
        sessionID: "",
        studentID: "",
        publishID: ""
      }
    };
  },
  created() {
    this.getSessionNodeList();
  },
  methods: {
    close(val) {
      this.isClose = val;
    },
    detialsBtn(item) {
      this.isClose = true;
      this.row["sessionID"] = this.sId;
      this.row["studentID"] = item.StudentID;
      this.row["publishID"] = item.PublishID;
    },
    async getSessionNodeList() {
      //获取学年学期
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.xyMApi}/xy/Comm/GetSessionNodeList`,
        null
      );
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.yearList.push({
              IsCurrent: item.IsCurrent,
              text: item.label,
              value: item.value,
              children: item.children
            });
          });
          this.yearList.map(item => {
            if (item.IsCurrent) {
              this.yId = item.value; //当前学年
              item.children.map(child => {
                this.sessionList.push({
                  IsCurrent: child.IsCurrent,
                  text: child.label,
                  value: child.value
                });
                if (child.IsCurrent) {
                  this.sId = child.value; //当前学期
                }
              });
            }
          });
          if (this.yId !== "" && this.sId !== "") this.getProgramme();
        }
      }
    },
    async getProgramme() {
      //获取我的学生
      this.xy.loading();
      this.pList = [];
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/MyStudent/GetStudentListDistinct`,
        {
          sessionID: this.sId
        }
      );
      if (res.success) {
        this.list = res.data;
      }
      this.xy.unloading();
    },
    yChange(item) {
      //切换学年
      this.sessionList = [];
      for (let i = 0, len = this.yearList.length; i < len; i++) {
        if (item === this.yearList[i].value) {
          this.yearList[i].children.map(child => {
            this.sessionList.push({
              text: child.label,
              value: child.value
            });
          });
        }
      }
      this.sId = this.sessionList[0].value;
      this.getProgramme();
    },
    sChange() {
      //切换学期
      this.getProgramme();
    }
  }
};
</script>
<style lang="less" scoped>
.my-student-count {
  text-align: right;
  padding: 20px 40px 20px 0;
}
.my-student-body {
  width: 90%;
  margin: 0 auto;
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 20px;
    margin-bottom: 40px;
    border-radius: 8px;
    box-shadow: 0px 2px 6px 0px rgba(166, 187, 207, 0.3);
    .list-info {
      padding-right: 40px;
      .student-name {
        font-size: 28px;
      }
      .student-username,
      .student-classname {
        margin: 20px 0;
        font-size: 26px;
        color: #999;
      }
    }
  }
}
</style>
